module.exports = __webpack_public_path__ + "static/img/wap_banner_1.ef33e7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/mExtensionPage/wap_banner_1.png
// module id = wlg6
// module chunks = 0